// MainRouter.tsx
import React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";


// --- Common Components ---
import Navbar from "../CommonComponents/Navbar/navbar";
import Footer from "../CommonComponents/Navbar/footer/footer";
import Sidebar, { MobileSideBar } from "../CommonComponents/Navbar/sidebar/sideBar";
import LevelRouteWrapper from "./components/routeGuardWrapper"
// --- Hooks & Utils ---
import { useLocalStorageToggle, useMediaQuery } from "../../hooks/common";
import { cookieUtils } from "../../utils/cookieUtils";

//constants
import { routesConfig } from "./constant/routeConstant";

// ====================
// Whitelist Routes
// ====================
const whitelistRoutes = ["/account-verification-status", "/launch-page", "user-profile", "onboarding/forgot-password", "onboarding/create-account", "about", "onboarding/change-password"];




// ====================
// Main Routes Component
// ====================
function MainRouter({ sidebar, toggleSidebar, hideSidebar, sidebarToRender }: any) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const location = useLocation();

  // React.useEffect(() => {
  //   const userRegistrationDetails = JSON.parse(
  //     localStorage.getItem("userRegistrationDetails") || "{}"
  //   ) as Record<string, any>;
  //   const userDetails = cookieUtils.getSecureCookie("userDetails");

  //   if (!whitelistRoutes.includes(location.pathname)) {
  //     if (
  //       userRegistrationDetails &&
  //       Object.keys(userRegistrationDetails).length !== 0 &&
  //       userDetails?.role === "user"
  //     ) {
  //       if (userRegistrationDetails?.regestration_status !== 1) {
  //         // Uncomment the following line to navigate when verification fails:
  //         // navigate('/user-account-not-verified');
  //       }
  //     }
  //   }
  // }, [location.pathname, navigate]);

  // Common layout wrapper that includes Navbar, optional Sidebar, and Footer.
  const RegularWrapper = ({ children }: { children: React.ReactNode }) => (
    <div className="h-screen flex flex-col">
      <Navbar isSidebarOpen={sidebar} toggleSidebar={toggleSidebar} />
      <div className="relative grow flex overflow-y-auto">
        {!hideSidebar && sidebarToRender}
        <div
          className="bg-secondary w-full min-w-[100px] grow h-full flex flex-col"
          style={{ transition: "width 0.3s, margin-left 0.3s" }}
        >
          <div className="grow overflow-y-auto box-border">{children}</div>
          <Footer />
        </div>
      </div>
    </div>
  );

  return (
    <Routes>
      {routesConfig.map((route, index) => {
        console.log("currentRout", route)
        const { Component } = route
        const WrappedComponent = (
          <LevelRouteWrapper levelData={route.level}>
            <RegularWrapper><Component /></RegularWrapper>
            </LevelRouteWrapper>
        );

            return <Route key={index} path={route.path} element={WrappedComponent} />;
      })}
          </Routes>
        );
      }

export default MainRouter;
